var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-package",
        hideHeader: "",
        hideHeaderClose: "",
        hideFooter: "",
        noCloseOnBackdrop: "",
        noCloseOnEsc: "",
        size: "md"
      }
    },
    [
      _c(
        "div",
        { staticClass: "custom-modal-body container p-0" },
        [
          _vm.currentPackage
            ? _c("Package", {
                staticClass: "custom-package",
                attrs: {
                  packageKey: _vm.packageItem.packageKey,
                  title: _vm.packageItem.title,
                  appIcon: _vm.packageItem.appIcon,
                  appColor: _vm.packageItem.appColor,
                  masterPriceList: _vm.packageItem.masterPriceList,
                  apps: _vm.packageItem.apps,
                  isFocus: _vm.packageItem.isFocus,
                  isShowInfo: false,
                  isShowBackHomeButton: true,
                  advancedTableRows: _vm.packageItem.advancedTableRows,
                  addOnTableRows: _vm.packageItem.addOnTableRows,
                  channelTableRows: _vm.packageItem.channelTableRows,
                  payButtonText: _vm.packageItem.payButtonText,
                  payButtonClass: _vm.packageItem.payButtonClass
                },
                on: { onSubmit: _vm.handleSubmit }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-541d7208", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-541d7208","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseModalPackage.vue
// module id = null
// module chunks = 